import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopPicksRow.css';

// ADDED imports for your new local icon components
import CodeIcon from './icons/CodeIcon';
import BriefcaseIcon from './icons/BriefcaseIcon';
import CertificateIcon from './icons/CertificateIcon';
import ProjectDiagramIcon from './icons/ProjectIcon';
import EnvelopeIcon from './icons/EnvelopeIcon';
import MusicIcon from './icons/MusicIcon';
import FilmIcon from './icons/FilmIcon';

// Define your ProfileType here
type ProfileType = 'recruiter' | 'developer' | 'stalker' | 'adventure';

// Define props type for the component
interface TopPicksRowProps {
  profile: ProfileType;
}

interface Pick {
  title: string;
  imgSrc: string;
  icon: React.ComponentType<{ style?: React.CSSProperties }>;
  route: string;
}

const topPicksConfig: Record<ProfileType, Pick[]> = {
  recruiter: [
    { title: "Skills", imgSrc: "https://t3.ftcdn.net/jpg/02/24/60/02/360_F_224600298_GRtqns591VsE7MzBkS6iDNLSpRGXpugv.jpg", icon: CodeIcon, route: "/skills" },
    { title: "Education", imgSrc: "https://picsum.photos/seed/workexperience/250/200", icon: BriefcaseIcon, route: "/work-experience" },
    { title: "Certifications", imgSrc: "https://picsum.photos/seed/certifications/250/200", icon: CertificateIcon, route: "/certifications" },
    { title: "Projects", imgSrc: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEj70JI20GF9vOkFF1htVsZZtH0oOpiwHDLaJLpsPFyXhaATrKAT1CDbjoiZVEwNTyE9HWWCKoZUG86b5eBqsDV5wpAQAxTJtFfi3_vpz7elXa8_fhyphenhypheneVofUZR90HsiXC-Y7-zVB6-EJUR11k8_PHHQes1uLr4JVDT6-bsrP3bLr0GHZ0Jtze96bJm2yBiE/s1600/luffy-onepiece-anime-wallpaper-4k%20(6).png", icon: ProjectDiagramIcon, route: "/projects" },
    { title: "Contact Me", imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBRPLBzDtX_pZHMVHkU7TZClVJ6M4oJ88BOQ&s", icon: EnvelopeIcon, route: "/contact-me" }
  ],
  developer: [
    { title: "Skills", imgSrc: "https://wallpapers-clan.com/wp-content/uploads/2024/04/aesthetic-berserk-guts-dark-desktop-wallpaper-preview.jpg", icon: CodeIcon, route: "/skills" },
    { title: "Projects", imgSrc: "https://img.freepik.com/premium-photo/futuristic-samurai-standing-building-cyberpunk-city-rainy-night-digital-art-style-illustration-painting_37402-522.jpg?semt=ais_hybrid&w=740&q=80", icon: ProjectDiagramIcon, route: "/projects" },
    { title: "Certifications", imgSrc: "https://applescoop.org/image/wallpapers/mac/night-mode-anime-style-cottage-on-a-hill-at-dark-night-best-most-popular-free-download-wallpapers-for-macbook-pro-and-macbook-air-and-microsoft-windows-desktop-pcs-4k-07-12-2024-1733638190-hd-wallpaper.webp", icon: CertificateIcon, route: "/certifications" },
    { title: "Education", imgSrc: "https://wallpapers.com/images/hd/dark-anime-scenery-mkvyv6r96pmwro5n.jpg", icon: BriefcaseIcon, route: "/work-experience" },
    { title: "Contact Me", imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRqM7o-uCtW9dxG5ecKfI2XUQpCpUZtDj62-k9eUBTBJzrQHwNffs83R8kdqZCEFqOku10&usqp=CAU", icon: EnvelopeIcon, route: "/contact-me" }
  ],
  stalker: [
    { title: "Contact Me", imgSrc: "https://wallpapercave.com/wp/wp7251530.jpg", icon: EnvelopeIcon, route: "/contact-me" },
    { title: "Projects", imgSrc: "https://4kwallpapers.com/images/wallpapers/black-panther-marvel-superheroes-black-background-amoled-5k-2880x1800-8385.jpg", icon: ProjectDiagramIcon, route: "/projects" },
    { title: "Education", imgSrc: "https://wallpapercat.com/w/full/1/9/1/118652-3840x2160-desktop-4k-avengers-background-image.jpg", icon: BriefcaseIcon, route: "/work-experience" },
    { title: "Certifications", imgSrc: "https://c4.wallpaperflare.com/wallpaper/972/818/492/avengers-windows-hd-download-wallpaper-preview.jpg", icon: CertificateIcon, route: "/certifications" },
  ],
  adventure: [
    { title: "Music", imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBRPLBzDtX_pZHMVHkU7TZClVJ6M4oJ88BOQ&s", icon: MusicIcon, route: "/music" },
    { title: "Projects", imgSrc: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/ac7d1c8d-1921-474d-8b70-12169bfb149e/dfqv3bi-89dc678f-6f44-40eb-9237-a2f8fd778da8.png/v1/fill/w_1280,h_720,q_80,strp/dark_desktop_background_in_4k_one_piece_by_trutkach_dfqv3bi-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzIwIiwicGF0aCI6IlwvZlwvYWM3ZDFjOGQtMTkyMS00NzRkLThiNzAtMTIxNjliZmIxNDllXC9kZnF2M2JpLTg5ZGM2NzhmLTZmNDQtNDBlYi05MjM3LWEyZjhmZDc3OGRhOC5wbmciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.5P79_oal_SN7IvT7OR1bzj2Ygn2cdtRVPJc6ye-K06U", icon: ProjectDiagramIcon, route: "/projects" },
    { title: "Anime", imgSrc: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTt2irGMUnsziHow6ceKXwLuceXdn_UVAkGCLEQsSZAK-HGeANfA75YM6M7s-11nXsPAw&usqp=CAU", icon: FilmIcon, route: "/Anime" },
    { title: "Contact Me", imgSrc: "https://wallpapers-clan.com/wp-content/uploads/2024/04/sanji-smoking-one-piece-desktop-wallpaper-preview.jpg", icon: EnvelopeIcon, route: "/contact-me" },
    { title: "Certifications", imgSrc: "https://4kwallpapers.com/images/wallpapers/shanks-5k-one-piece-5120x2880-18352.jpg", icon: CertificateIcon, route: "/certifications" }
  ]
};

const TopPicksRow: React.FC<TopPicksRowProps> = ({ profile }) => {
  const navigate = useNavigate();
  const topPicks = topPicksConfig[profile];

  return (
    <div className="top-picks-row">
      <h2 className="row-title">Today's Top Picks for {profile}</h2>
      <div className="card-row">
        {topPicks.map((pick, index) => {
          const IconComponent = pick.icon;
          return (
            <div
              key={index}
              className="pick-card"
              onClick={() => navigate(pick.route)}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <img src={pick.imgSrc} alt={pick.title} className="pick-image" />
              <div className="overlay">
                <div className="pick-label">
                  <IconComponent style={{ marginRight: '8px' }} /> {pick.title}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopPicksRow;
